// SceneIframePanel.jsx
import React from "react";
import { SceneIframe } from "./SceneIframe";

export function SceneIframePanel({ shortLink, fallbackUrl, accessToken,routeId,scene }) {
  /*if (!shortLink && !fallbackUrl) {
    return <p><div style={{ marginTop: "20px" }} className="intro-sections">
            <div className="intro-section rutas-creadas">
              <h2 className="intro-title">Clase Virtual</h2>
              <p className="intro-description">
                Ahora selecciona la escena por donde quieras que la clase comience el Itinerario.
              </p>
              <hr className="intro-divider" />
            </div>
          </div></p>;
  }*/

  return (
    <div style={{ width: "100%", minHeight: "100%", background: "#ddd" }}>
      <SceneIframe
        accessToken={accessToken}
        shortLink={shortLink}
        fallbackUrl={fallbackUrl}
        routeId={routeId}
        scene={scene}
      />
    </div>
  );
}
